import { useState } from 'react';
import { FormHelperText, TextField } from '@mui/material';

export default function PSNameEdit(props) {
  const { id, field, value, api, setterFn } = props;
  const [isRecentlyAdded, setIsRecentlyAdded] = useState(false);
  const [inError, setInError] = useState(false);

  const handleChange = (event, callSetter) => {
    const newValue = event.target.value;

    setInError(newValue?.trim() === '');

    api.setEditCellValue({ id, field, value: newValue }, event);

    if (callSetter && newValue.trim() !== '' && !isRecentlyAdded) {
      setIsRecentlyAdded(true);
      setterFn(newValue.trim(), id);
      setTimeout(() => {
        setIsRecentlyAdded(false);
        api.startCellEditMode({ id, field: 'status' });
      }, 100);
    }
  };

  const handleKeyboardChange = (event, callSetter) => {
    if (event.key === 'Tab' || event.key === 'Enter') {
      handleChange(event, callSetter);
    }
  };

  return (
    <div style={{ width: '100%', marginTop: '5px' }}>
      <TextField
        fullWidth
        value={value}
        onKeyDown={(e) => handleKeyboardChange(e, true)}
        onChange={(e) => handleChange(e, false)}
        onBlur={(e) => handleChange(e, true)}
        placeholder="Non Current Supplier Name"
        size="small"
        autoFocus={true}
        error={inError}
      />
      {inError && (
        <FormHelperText error={inError} sx={{ fontSize: '14px' }}>
          Name is required.
        </FormHelperText>
      )}
    </div>
  );
}
